<script lang="ts">
  import type { StatuteBill, BankMatch, EasyJetPlusAnswer } from "../types";
  import { formatGbp } from "../../../lib/formatting";
  import FooterButtons from "../../../components/workflow/FooterButtons.svelte";
  import StatuteBillSummary from "../elements/StatuteBillSummary.svelte";
  import BankAccountInfo from "../../Settlement/elements/BankAccountInfo.svelte";
  import Faqs from "../faqs/Faqs.svelte";
  import DownloadLink from "../../Settlement/elements/DownloadLink.svelte";
  import CloseButton from "../../../components/CloseButton.svelte";
  import EasyJetPlusNote from "../elements/EasyJetPlusNote.svelte";

  let {
    payoutAmount,
    statuteBill,
    bankMatch,
    easyJetPlusUrl,
    easyJetPlusAnswer,
  }: {
    payoutAmount: number;
    statuteBill: StatuteBill;
    bankMatch: BankMatch;
    easyJetPlusUrl?: string;
    easyJetPlusAnswer: EasyJetPlusAnswer;
  } = $props();
</script>

<h2 class="ui-title">Your payment is on its way</h2>

<p>
  We've sent {formatGbp(payoutAmount)} to your bank account. Funds typically arrive within a few business
  days, depending on your bank. If you don't see it after that, let us know and we'll look into it.
</p>

<EasyJetPlusNote url={easyJetPlusUrl} status={easyJetPlusAnswer} />

<StatuteBillSummary {statuteBill} {payoutAmount} class="mb-4" />

<DownloadLink label="Download statute bill" href={statuteBill.download} class="mb-6" />

<BankAccountInfo {bankMatch} showHeader={true} />

<h3 class="ui-section-title">Have questions?</h3>
<Faqs />
<FooterButtons back={false}>
  {#if easyJetPlusAnswer === "claimed" || !easyJetPlusUrl}
    <CloseButton class="btn-primary w-full" />
  {:else}
    <CloseButton />
    <a href={easyJetPlusUrl} class="btn btn-primary" data-turbo-frame="task-modal">Claim year of easyJet Plus</a>
  {/if}
</FooterButtons>
